import { BaseAPIClient } from "./baseApi";

const POST = "POST";
const PUT = "PUT";
const GET = "GET";
const DELETE = "DELETE";

export class PitchApi extends BaseAPIClient {
  validateEmail(email) {
    return this.call("/check-email", GET, email);
  }

  signIn(credentials) {
    return this.call("/sign-in", POST, credentials);
  }

  signUp(customerData) {
    return this.call("/sign-up", POST, customerData);
  }

  activateAccount(id) {
    return this.call(`/validate-email/${id}`, GET);
  }

  requestRecoverPassword(email) {
    return this.call("/recover", POST, { email });
  }

  validateOtp(otp) {
    return this.call(`/valid/${otp}`, GET);
  }

  updatePassword(data) {
    return this.call("/password", POST, data);
  }

  showProfile() {
    return this.call("/profile", GET);
  }

  updateProfile(data) {
    return this.call("/profile", PUT, data);
  }

  removerDisponibilidade(id) {
    return this.call(`/profile/update/${id}`, DELETE);
  }

  doAMatch() {
    return this.call("/match", GET);
  }

  requestJoin(data) {
    return this.call("/join", POST, data);
  }

  getCourse() {
    return this.call("/course", GET);
  }

  getCourseContent(id) {
    return this.call(`/course/${id}`, GET);
  }

  addCourseContentNote(id, note) {
    return this.call(`/course/${id}/add-note`, POST, { note });
  }

  calendar() {
    return this.call(`/calendar`, GET);
  }

  groups() {
    return this.call("/groups", GET);
  }

  getNotifications() {
    return this.call("/notifications", GET);
  }

  readNotification(id) {
    return this.call(`/notifications/${id}`, PUT);
  }

  rearrange(eventId, classId) {
    return this.call(`/calendar/events/${eventId}/${classId}/rearrange`);
  }

  postergate(id, data) {
    return this.call(`/calendar/events/${id}`, PUT, data);
  }

  vote(id, option) {
    return this.call(`/calendar/vote/${id}`, POST, { agreed: option });
  }
}

const api = new PitchApi(process.env.VUE_APP_PITCH_API_CUSTOMER);

export default api;
